<template>
    <div class="filter-content-entry" data-tab="features">
        <div class="filter-content-entry-mobile-title">
            <a href="#" class="btn btn-rebrand-grey-outline btn-rebrand-xxs px-2 back">{{translate.account.onboard.back}}</a>
            <span class="filter-title">{{translate.home.features}}</span>
            <a href="#" class="btn btn-rebrand-black btn-rebrand-xxs ml-auto px-2"
               @click.prevent="clearAllFilters()">{{translate.home.clearAll}}</a>
        </div>
        <div class="row mb-5 filter-content-your-selection">
            <div class="col-md-12">
                <div class="section-heading mt-0 pt-0 border-0">{{ translate.home.yourSelection }}</div>
                <div class="filter-content-your-selection-list">
                    <search-filter-flairs-scoped-component
                            :filterProp="'features'"
                    ></search-filter-flairs-scoped-component>
                    <a href="#" class="clear-filter-link"
                       @click.prevent="clearAllFilters()">{{ translate.home.clearAll }}</a>
                </div>
            </div>
        </div>
        <div class="row filter-content-container justify-content-between" v-if="featureOptions">

            <div class="col-md-4 col-lg-3">
                <!-- GENDER -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow accordion-title--no-border-mobile">
                        {{ translate.user_features.gender }}</div>
                    <div id="filter-gender" class="accordion-content accordion-content--small">
                        <div class="radio-group-v2 radio-group--small">
                            <input type="radio" name="features-gender" id="input_features_gender_female"
                                   @click="onGenderSelected('Weiblich')"
                                   value="female"
                                   class="form-check-input"
                                   :checked="featuresTemp.gender === 'Weiblich'"
                            >
                            <label for="input_features_gender_female">{{ translate.user_features.genders.female }}</label>

                            <input type="radio" name="features-gender" id="input_features_gender_male"
                                   @click="onGenderSelected('Männlich')"
                                   value="male"
                                   class="form-check-input"
                                   :checked="featuresTemp.gender === 'Männlich'"
                            >
                            <label for="input_features_gender_male">{{ translate.user_features.genders.male }}</label>

                            <input type="radio" name="features-gender" id="input_features_gender_trans"
                                   @click="onGenderSelected('Transsexuell')"
                                   value="transsexual"
                                   class="form-check-input"
                                   :checked="featuresTemp.gender === 'Transsexuell'"
                            >
                            <label for="input_features_gender_trans">{{ translate.user_features.genders.trans }}</label>

                            <input type="radio" name="features-gender" id="input_features_gender_all"
                                   @click="onGenderSelected(null)"
                                   value="all"
                                   class="form-check-input"
                                   :checked="!featuresTemp.gender"
                            >
                            <label for="input_features_gender_all">{{ translate.home.all }}</label>
                        </div>

                    </div>
                </div>

                <!-- AGE -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.age }}</div>
                    <div id="filter-age" class="accordion-content accordion-content--small">
                        <vue-slider v-model="sliders.age"
                                    class="vue-slider--redesign"
                                    @change="onFilterUpdatedSlider($event,'age')"
                                    :min="slidersDefault.age[0]"
                                    :max="slidersDefault.age[1]"
                                    :interval="1"
                                    :silent="true"
                                    :tooltip="'always'"
                                    :tooltip-placement="'bottom'"/>
                    </div>
                </div>

                <!-- BODY TYPE -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.body_type }}</div>
                    <div id="filter-body-type" class="accordion-content accordion-content--small">
                        <div class="dropdown-in-select-style-v2">
                            <button class="dropdown-in-select-style-v2--toggle"
                                    type="button" id="dropdownSelectBodyType"
                                    data-toggle="dropdown"
                                    data-display="static"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                {{ displayDropdownSelected('body_type', 'body type') }}
                            </button>
                            <div class="dropdown-menu dropdown-in-select-style-v2--menu" @click.stop
                                 aria-labelledby="dropdownSelectBodyType">
                                <div class="checkbox-list-v2">
                                    <template v-for="(value,i) in featureOptions.body_type">
                                        <input
                                                @click="onFilterUpdatedList('body_type', value)"
                                                type="checkbox" :id="'body-type-' + i" :value="value"
                                                :checked="lodash.get(featuresTemp,'lists.body_type', []).includes(value)"
                                        >
                                        <label :for="'body-type-' + i">{{ translateFeature(value, 'body_type') }}</label>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-3">
                <!-- SKIN COLOR -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.skin_color }}</div>
                    <div id="filter-skin-color" class="accordion-content accordion-content--small">
                        <div class="dropdown-in-select-style-v2">
                            <button class="dropdown-in-select-style-v2--toggle"
                                    type="button" id="dropdownSelectSkinColor"
                                    data-toggle="dropdown"
                                    data-display="static"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                {{ displayDropdownSelected('skin_color', 'skin color') }}
                            </button>
                            <div class="dropdown-menu dropdown-in-select-style-v2--menu" @click.stop
                                 aria-labelledby="dropdownSelectSkinColor">
                                <div class="checkbox-list-v2">
                                    <template v-for="(value,i) in featureOptions.skin_color">
                                        <input
                                                @click="onFilterUpdatedList('skin_color', value)"
                                                type="checkbox" :id="'skin-color-' + i" :value="value"
                                                :checked="lodash.get(featuresTemp,'lists.skin_color', []).includes(value)"
                                        >
                                        <label :for="'skin-color-' + i">{{  translateFeature(value, 'skin_color') }}</label>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- ETHNICITY -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.ethnicity }}</div>
                    <div id="filter-ethnicity" class="accordion-content accordion-content--small">
                        <div class="dropdown-in-select-style-v2">
                            <button class="dropdown-in-select-style-v2--toggle"
                                    type="button" id="dropdownSelectEthnicity"
                                    data-toggle="dropdown"
                                    data-display="static"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                {{ displayDropdownSelected('ethnicity') }}
                            </button>
                            <div class="dropdown-menu dropdown-in-select-style-v2--menu" @click.stop
                                 aria-labelledby="dropdownSelectEthnicity">
                                <div class="checkbox-list-v2">
                                    <template v-for="(value,i) in featureOptions.ethnicity">
                                        <input
                                                @click="onFilterUpdatedList('ethnicity', value)"
                                                type="checkbox" :id="'ethnicity-' + i" :value="value"
                                                :checked="lodash.get(featuresTemp,'lists.ethnicity', []).includes(value)"
                                        >
                                        <label :for="'ethnicity-' + i">{{  translateFeature(value, 'ethnicity') }}</label>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- BREAST SIZE -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.breast_size }}</div>
                    <div id="filter-breast-size" class="accordion-content accordion-content--small">
                        <div class="dropdown-in-select-style-v2">
                            <button class="dropdown-in-select-style-v2--toggle"
                                    type="button" id="dropdownSelectBreastSize"
                                    data-toggle="dropdown"
                                    data-display="static"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                {{ displayDropdownSelected('breast_size', 'breast size') }}
                            </button>
                            <div class="dropdown-menu dropdown-in-select-style-v2--menu" @click.stop
                                 aria-labelledby="dropdownSelectBreastSize">
                                <div class="checkbox-list-v2">
                                    <template v-for="(value,i) in featureOptions.breast_size">
                                        <input
                                                @click="onFilterUpdatedList('breast_size', value)"
                                                type="checkbox" :id="'breast-size-' + i" :value="value"
                                                :checked="lodash.get(featuresTemp,'lists.breast_size', []).includes(value)"
                                        >
                                        <label :for="'breast-size-' + i">{{  translateFeature(value, 'breast_size') }}</label>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-3">
                <!-- HAIR COLOR -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.hair_color }}</div>
                    <div id="filter-hair-color" class="accordion-content accordion-content--small">
                        <div class="dropdown-in-select-style-v2">
                            <button class="dropdown-in-select-style-v2--toggle"
                                    type="button" id="dropdownSelectHairColor"
                                    data-toggle="dropdown"
                                    data-display="static"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                {{ displayDropdownSelected('hair_color', 'hair color') }}
                            </button>
                            <div class="dropdown-menu dropdown-in-select-style-v2--menu" @click.stop
                                 aria-labelledby="dropdownSelectHairColor">
                                <div class="checkbox-list-v2">
                                    <template v-for="(value,i) in featureOptions.hair_color">
                                        <input
                                                @click="onFilterUpdatedList('hair_color', value)"
                                                type="checkbox" :id="'hair-color-' + i" :value="value"
                                                :checked="lodash.get(featuresTemp,'lists.hair_color', []).includes(value)"
                                        >
                                        <label :for="'hair-color-' + i">{{  translateFeature(value, 'hair_color') }}</label>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- WEIGHT -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.weight }}</div>
                    <div id="filter-weight" class="accordion-content accordion-content--small">
                        <vue-slider v-model="sliders.weight"
                                    class="vue-slider--redesign"
                                    @change="onFilterUpdatedSlider($event,'weight')"
                                    :min="slidersDefault.weight[0]"
                                    :max="slidersDefault.weight[1]"
                                    :interval="1"
                                    :silent="true"
                                    :tooltip="'always'"
                                    :tooltip-placement="'bottom'"
                                    :tooltip-formatter="'{value}KG'"/>
                    </div>
                </div>

                <!-- NATIONALITY -->
                <div class="accordion--filter">
                    <div class="accordion-title accordion-title--no-arrow">{{ translate.user_features.nationality }}</div>
                    <div id="filter-nationality" class="accordion-content accordion-content--small">
                        <div class="dropdown-in-select-style-v2">
                            <button class="dropdown-in-select-style-v2--toggle"
                                    type="button" id="dropdownSelectNationality"
                                    data-toggle="dropdown"
                                    data-display="static"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                {{ displayDropdownSelected('nationality') }}
                            </button>
                            <div class="dropdown-menu dropdown-in-select-style-v2--menu" @click.stop
                                 aria-labelledby="dropdownSelectNationality">
                                <div class="search-input search-input--inner search-input--redesign">
                                    <input type="text" id="searchNationality"
                                           v-model="nationalityFilter" :placeholder="translate.home.search + ' ' + translate.user_features.nationality">
                                </div>
                                <div class="checkbox-list-v2">
                                    <template v-for="(value,i) in nationalityFiltered">
                                        <input @click="onFilterUpdatedList('nationality', value)"
                                               type="checkbox" :id="'nationality-' + i" :value="value"
                                               :checked="lodash.get(featuresTemp,'lists.nationality', []).includes(value)"
                                        >
                                        <label :for="'nationality-' + i">{{  translateFeature(value, 'nationality') }}</label>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import translateMixin from "@/components/mixins/translateMixin";

    const data = () => {
        return {
            lodash: _,
            store: $store,
            sliders: {
                age: [18, 100],
                height: [0, 100],
                weight: [0, 100],
            },
            slidersDefault: {
                age: [18, 100],
                height: [0, 100],
                weight: [0, 100],
            },
            cup_size: {
                from: null,
                to: null,
            },
            cup_size_options: {
                from: [],
                to: [],
            },
            unSubscribe: null,
            nationalityFilter: '',
        }
    };

    async function created() {
        this.cup_size_options.from = this.featureOptions.cup_size;
        this.cup_size_options.to = this.featureOptions.cup_size;

        if (_.get(this, 'ranges.age_range.1', null)) {
            this.slidersDefault.age = this.sliders.age = this.ranges.age_range;

            if (this.sliders.age[0] < 18) {
                this.slidersDefault.age[0] = this.sliders.age[0] = 18;
            }
        }

        if (_.get(this, 'ranges.height_range', []).length === 2) {
            this.slidersDefault.height = this.sliders.height = this.ranges.height_range;
        }

        if (_.get(this, 'ranges.weight_range', []).length === 2) {
            this.slidersDefault.weight = this.sliders.weight = this.ranges.weight_range;
        }
    }

    function mounted() {
        this.unSubscribe = this.store.subscribe((mutation) => {
            if (mutation.type === 'setFilterOpened'
                && mutation.payload
                && (!Object.keys(this.featuresTemp).length)
            ) {
                let features = _.cloneDeep(this.features);

                // we set the default filter to `female` gender
                // because the `SeoRepository->getProfileOrSearchResults`
                // already filtered the results if it was the initial request
                // or initial request coming from the homepage appended the filter.
                //
                // See:
                // 1) `MainSearchComponent->mounted` (`payloadObj.features.gender = 'Weiblich'`)
                // 2) `SeoRepository->getProfileOrSearchResults`
                if (typeof features.gender === 'undefined') {
                    features.gender = 'Weiblich';
                }

                this.store.commit('setFeaturesTemp', features);
            }
        });
    }

    function generateCupSizes(chest_sizes, cup_sizes) {
        const new_cup_sizes = [];
        _.each(chest_sizes, chest => {
            _.each(cup_sizes, cup => {
                new_cup_sizes.push(chest + cup);
            });
        });
        return new_cup_sizes;
    }

    function onFilterUpdatedSlider(value, variable) {
        const tmp = _.cloneDeep(this.featuresTemp);
        tmp['sliders'] = tmp['sliders'] || {};
        tmp['sliders'][variable] = value;
        this.store.commit('setFeaturesTemp', tmp);
    }

    function onFilterUpdatedList(variable, value) {
        const tmp = _.cloneDeep(this.featuresTemp);
        tmp['lists'] = tmp['lists'] || {};
        const array = tmp['lists'][variable] || [];

        if (array.includes(value)) {
            array.splice(array.indexOf(value), 1);
        } else {
            array.push(value);
        }
        tmp['lists'][variable] = array;

        this.store.commit('setFeaturesTemp', tmp);
    }

    function onCupSizeUpdatedFrom(value) {
        this.onCupSizeSelected(value, _.get(this, 'featuresTemp.cup_size.to', null));
    }

    function onCupSizeUpdatedTo(value) {
        this.onCupSizeSelected(_.get(this, 'featuresTemp.cup_size.from', null), value);
    }

    function onCupSizeSelected(from, to) {
        const tmp = _.cloneDeep(this.featuresTemp) || {};

        const sizes = this.featureOptions.cup_size;
        let indexFrom = _.indexOf(sizes, from);
        let indexTo = _.indexOf(sizes, to);

        if (from && !to) {
            to = (sizes.length > indexFrom + 1) ? sizes[indexFrom + 1] : sizes[indexFrom];
            indexTo = _.indexOf(sizes, to);
        } else if (!from && to) {
            from = (indexTo > 0) ? sizes[indexTo - 1] : sizes[indexTo];
            indexFrom = _.indexOf(sizes, from);
        }

        tmp['cup_size'] = {from, to};
        this.store.commit('setFeaturesTemp', tmp);

        if (indexFrom >= 0) {
            this.cup_size_options.to = _.slice(sizes, indexFrom);
        }
        if (indexTo >= 0) {
            this.cup_size_options.from = _.slice(sizes, 0, indexTo + 1);
        }

    }

    function onGenderSelected(value) {
        let tmp = _.cloneDeep(this.featuresTemp);
        tmp.gender = value;
        this.store.commit('setFeaturesTemp', tmp);
    }

    function clearAllFilters() {
        this.store.commit('setFeaturesTemp', {});
    }

    function displayDropdownSelected(key, name = key) {

        if (_.get(this, `featuresTemp.lists.${key}`, []).length > 1) {
            return this.featuresTemp.lists[key].length + ` ${this.translate.home.selected}`;
        }

        if (_.get(this, `featuresTemp.lists.${key}.0`, false)) {
            return this.translateFeature(this.featuresTemp.lists[key][0], key);
        }

        const nameKey = _.replace(name, ' ', '_');
        return _.get(this, 'translate.home.select') + ' ' + _.get(this, `translate.user_features.${nameKey}`, name);
    }

    export default {
        data,
        created,
        mounted,
        computed: {
            ...mapState([
                'features',
                'featuresTemp',
                'translate',
                'featureOptions',
                'ranges',
            ]),
            nationalityFiltered() {
                const nationality = _.get(this, 'featureOptions.nationality', []);

                if (_.isEmpty(this.nationalityFilter)) {
                    return nationality;
                }

                return _.filter(nationality, value => {
                    return _.toLower(this.translateFeature(value, 'nationality')).includes(_.toLower(this.nationalityFilter));
                });
            }
        },
        watch: {
            featuresTemp(value) {
                this.sliders.age = (_.get(value, 'sliders.age', []).length === 2
                    ? value.sliders.age
                    : this.slidersDefault.age);

                this.sliders.weight = (_.get(value, 'sliders.weight', []).length === 2
                    ? value.sliders.weight
                    : this.slidersDefault.weight);

                this.sliders.height = (_.get(value, 'sliders.height', []).length === 2
                    ? value.sliders.height
                    : this.slidersDefault.height);
            },
            featureOptions(value) {
                this.cup_size_options.from = value.cup_size;
                this.cup_size_options.to = value.cup_size;
            }
        },
        mixins: [translateMixin],
        methods: {
            clearAllFilters,
            generateCupSizes,
            displayDropdownSelected,
            onFilterUpdatedSlider,
            onFilterUpdatedList,
            onCupSizeUpdatedFrom,
            onCupSizeUpdatedTo,
            onCupSizeSelected,
            onGenderSelected,
        },
        beforeDestroy() {
            if (this.unSubscribe) {
                this.unSubscribe();
            }
        },
    }
</script>
